import moment from 'moment';

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { month: 'short', day: 'numeric', year: '2-digit' };
  return new Intl.DateTimeFormat('en-US', options).format(date).replace(',', '');
};

export const canAttempt = (act) => {
  // 1. Safely get the first answer or null
  const firstAnswer = act?.activityAnswers?.length ? act.activityAnswers[0] : null;

  // 2. Safely get activitySettings (or default to {})
  const activitySettings = firstAnswer?.classId?.activitySettings || {};
  const { isPastDueAllowed = false, multipleAttempts = {} } = activitySettings;

  // 3. Safely extract multipleAttempts fields with defaults
  const { isAllowed = false, count = 0 } = multipleAttempts;

  // 4. Safely compute previousAnswers length and isSubmitted
  const prevCount = firstAnswer?.previousAnswers?.length || 0;
  const isSubmitted = firstAnswer?.isSubmitted || false;
  let submitCount = prevCount + (isSubmitted ? 1 : 0);

  let canAtt = true;

  // 5. Only check assignedDate if present
  if (act?.assignedDate && moment(act.assignedDate).isBefore(moment(), 'day')) {
    canAtt = Boolean(isPastDueAllowed);
  }

  // 6. Check submission limits
  if ((!isAllowed && isSubmitted) || (isAllowed && submitCount >= Number(count))) {
    canAtt = false;
  }

  return canAtt;
};

export const calculateLatePenalty = (act) => {
  // 1. Safely get the first answer object (or null if none)
  const firstAnswer = Array.isArray(act?.activityAnswers) && act.activityAnswers.length > 0 ? act.activityAnswers[0] : null;

  // 2. Safely get pastDuePenalty from nested activitySettings, or {} if missing
  const pastDuePenalty = firstAnswer?.classId?.activitySettings?.pastDuePenalty || {};
  const { percentage = 0, type = 'none' } = pastDuePenalty;

  // 3. If there's no assignedDate, return 0 immediately
  if (!act?.assignedDate) {
    return 0;
  }

  // 4. Compute days difference (you may choose to normalize to start of day)
  const daysDiff = moment().diff(moment(act.assignedDate).startOf('day'), 'days');

  // 5. Determine penalty
  let penalty;
  if (type !== 'perday') {
    penalty = type === 'none' ? 0 : 100;
  } else {
    penalty = percentage * daysDiff;
  }

  // 6. Cap at 100%
  return penalty > 100 ? 100 : penalty;
};
